import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { fetchRequestCounts } from "../../../api/t2tRequestsApi";

const CHIPS = [
  { key: "all",          label: "All",           countKey: "total_active", icon: "bi-inbox" },
  { key: "my_queue",     label: "My Queue",       countKey: "my_queue",     icon: "bi-person-check" },
  { key: "sla_breach",   label: "SLA Breach",     countKey: "sla_breach",   icon: "bi-exclamation-triangle-fill", danger: true },
  { key: "due_today",    label: "Due Today",      countKey: "due_today",    icon: "bi-calendar-event" },
  { key: "high_priority",label: "High Priority",  countKey: "high_priority",icon: "bi-arrow-up-circle-fill" },
];

export default function QuickFilterChips({ activeChip, onChange, refreshTrigger }) {
  const [counts, setCounts]   = useState({});
  const [loading, setLoading] = useState(true);

  const loadCounts = useCallback(async () => {
    setLoading(true);
    const resp = await fetchRequestCounts();
    if (!resp.error) setCounts(resp.data?.data || {});
    setLoading(false);
  }, []);

  useEffect(() => { loadCounts(); }, [loadCounts, refreshTrigger]);

  return (
    <div className="t2t-tab-group" style={{ flexWrap: "wrap" }}>
      {CHIPS.map((chip) => {
        const count   = counts[chip.countKey];
        const isActive = activeChip === chip.key;
        const isDangerActive = isActive && chip.danger;
        const hasDangerCount = !isActive && chip.danger && count > 0;
        return (
          <button
            key={chip.key}
            className={[
              "t2t-tab d-flex align-items-center gap-1",
              isActive && !chip.danger ? "active" : "",
              isDangerActive            ? "t2t-tab-danger-active" : "",
            ].filter(Boolean).join(" ")}
            onClick={() => onChange(chip.key)}
          >
            <i className={`bi ${chip.icon}`} style={{ fontSize: 11 }} />
            <span>{chip.label}</span>
            {!loading && count !== undefined && (
              <span className={hasDangerCount ? "rp-chip-count rp-chip-count-danger" : "rp-chip-count"}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

QuickFilterChips.propTypes = {
  activeChip:     PropTypes.string,
  onChange:       PropTypes.func.isRequired,
  refreshTrigger: PropTypes.number,
};
